import { InventoryService } from "@/services/nextshop/inventory.service.js";

export default {
  methods: {
    async searchOrderNo(value) {
      try {
        const param = {
          pageNum: "1",
          pageSize: "10",
          queryString: `{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN''' and {orderNo} =='''${value}'''`,
          sortBy: "id",
          sortType: "ASC",
        }

        const response = await InventoryService.checkinInvetory(param);

        if (response.success) {
          return response.data
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}